import { useCallback } from "react";

import { useBlock } from "@/components/PowerBlock/Block/block-store";
import { MCPConfiguration } from "@/types/evaluate";

const useHeadersManagement = (
  blockStore: ReturnType<typeof useBlock<MCPConfiguration>>,
  serverUrl: string,
) => {
  const handleHeadersChange = useCallback(
    (headers: Record<string, unknown>) => {
      blockStore.setConfiguration({
        ...blockStore.configuration,
        server_configuration: {
          ...blockStore.configuration?.server_configuration,
          server_url: serverUrl,
          headers,
        },
      } as MCPConfiguration);
    },
    [blockStore, serverUrl],
  );

  return {
    handleHeadersChange,
  };
};

export default useHeadersManagement;
